import { Col, Dropdown, Menu, Row, Modal, Input, Badge, Pagination } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import categoryProductAPI from '~/api/CategoryProductAPI';
import productAPI from '~/api/ProductAPI';
import { SVGS } from '~/assets/assetsPath';
import ItemProduct from '~/components/ItemProduct';
import styles from './ProductsFilter.module.scss';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { cartItemsCountSelector } from '~/pages/Cart/selector';
import FormFilterPrice from '~/components/FormFilterPrice';
import config from '~/config';

const cx = classNames.bind(styles);

const { Search } = Input;

const SearchComponent = styled.div`
    width: 100%;
    .ant-input-search-with-button .ant-input-group .ant-input {
        height: 44px;
        background-color: #fff7fd;
    }
    .ant-input-search-button {
        height: 44px;
    }
    .ant-btn-primary {
        background: #311d4f;
    }
    @media screen and (max-width: 480px) {
        margin: 20px 10px;
        /* .ant-input-search .ant-input-group .ant-input-group-addon:last-child {
            left: -215px;
        } */
        .ant-input-search-with-button .ant-input-group .ant-input {
            height: 44px;
            background-color: #f6f6f6;
        }
        .ant-btn-primary {
            background: #f6f6f6;
            border-left: unset;
            border-color: #e2e2e2;
            padding-top: 10px;
        }
        .anticon svg {
            color: #797979;
            height: 25px;
            width: 25px;
        }
    }
`;

const PaginationCustom = styled.div`
    .ant-pagination-options {
        display: none;
    }
`;

const ProductsFilter = () => {
    const navigate = useNavigate();

    const scrollRef = useRef();

    const location = useLocation();

    const cartItemsCount = useSelector(cartItemsCountSelector);

    const [listProduct, setListProduct] = useState([]);

    const [isLoading, setIsLoading] = useState(false);

    const [isHotDeal, setIsHotDeal] = useState(false);

    const [idCategory, setIdCategory] = useState('');

    const [categoryTitle, setCategoryTitle] = useState('');

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 12,
        total_item: 0,
        total_page: 0,
    });

    // const [rangePrice, setRangePrice] = useState([0, 10000000]);
    const [rangePrice, setRangePrice] = useState({
        priceLow: '',
        priceHigh: '',
    });

    const [filterOrder, setFilterOrder] = useState({ title: 'Price low to high', value: 'ASC', type: 'deducted_price' });

    const router = location?.search?.split('?').join('') || '';

    const goSearch = new URLSearchParams(router)?.get('go_search');

    const [isSearch, setIsSearch] = useState(goSearch || false);

    const [keySearch, setKeySearch] = useState('');

    const [isShowModalPrice, setIsShowModalPrice] = useState(false);

    const handleChangeKeySearch = (e) => {
        const value = e.target.value;
        setKeySearch(value);
    };

    const onSearch = (e) => {
        setIsSearch(false);
        handleGetListProduct(1, idCategory, isHotDeal, rangePrice, filterOrder, keySearch);
    };

    const handleSetShowModalPrice = () => {
        setIsShowModalPrice(false);
    };

    const handleGetListProduct = async (page, category_id, hot_deal, range_price, orderBy, search) => {
        try {
            setIsLoading(true);
            let range = [0, 10000000];
            if (!range_price.priceLow && !range_price.priceHigh) {
                range = [0, 10000000];
            } else {
                range = [range_price.priceLow, range_price.priceHigh];
            }
            let products = [];
            let final = [];
            let filter = `{"$and":[{"deducted_price": {"$between": [${range[0]}, ${range[1]}]}}, {"deducted_price": {"$gt": 0}}, {"type": "PRODUCT"}]}`;
            if (category_id) {
                filter = `{"$and":[{"category_id":  "${category_id}"}, {"deducted_price": {"$between": [${range[0]}, ${range[1]}]}}, {"deducted_price": {"$gt": 0}}, {"type": "PRODUCT"}]}`;
            } else if (hot_deal) {
                filter = `{"$and":[{"best_sale": true}, {"deducted_price": {"$between": [${range[0]}, ${range[1]}]}}, {"deducted_price": {"$gt": 0}}, {"type": "PRODUCT"}]}`;
            }

            const params = {
                fields: '["$all", {"category": ["$all"]}]',
                order: orderBy ? `[["${orderBy?.type}", "${orderBy?.value}"]]` : null,
                filter: filter,
                product: search,
                limit: pagination.limit,
                page: page,
            };
            const res = await productAPI.getListProductAPI(params);

            if (res.code === 200) {
                products = res.results.objects.rows;
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (products?.length) {
                final = [...new Map(products.map((item) => [item['id'], item])).values()];
            }
            setListProduct(final);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const handleSelectFilterOrder = (item) => {
        setFilterOrder(item);
        handleGetListProduct(1, idCategory, isHotDeal, rangePrice, item, keySearch);
    };

    // Get list Category
    const handleGetListCategory = async () => {
        try {
            let categories = [];
            const params = {
                fields: '["$all"]',
                order: '[["sort", "ASC"]]',
            };
            const res = await categoryProductAPI.getListCategory(params);
            if (res.code === 200) {
                categories = [...categories, ...res.results.objects.rows];
            }

            const search = location?.search?.split('?').join('') || '';
            const categoryId = new URLSearchParams(search)?.get('category_id');
            const cate_results = categories.filter((item) => item.id === categoryId);
            setCategoryTitle(cate_results[0]);
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangePagination = (page) => {
        scrollRef.current.scrollIntoView();
        setPagination({ ...pagination, page: page });
        handleGetListProduct(page, idCategory, isHotDeal, rangePrice, filterOrder, keySearch);

        // window.scrollTo(0, 0);
    };

    useEffect(() => {
        handleGetListCategory();
    }, []);

    useEffect(() => {
        const search = location?.search?.split('?').join('') || '';
        const categoryId = new URLSearchParams(search)?.get('category_id');
        const hotDeal = new URLSearchParams(search)?.get('hot_deal');

        if (hotDeal) {
            setIsHotDeal(true);
        }
        if (categoryId) {
            setIdCategory(categoryId);
        }
        handleGetListProduct(1, categoryId, hotDeal, rangePrice, filterOrder, keySearch);

        //eslint-disable-next-line
    }, [location?.search]);

    useEffect(() => {
        handleGetListProduct(1, idCategory, isHotDeal, rangePrice, filterOrder, keySearch);
        // eslint-disable-next-line
    }, [rangePrice]);

    const menuSort = (
        <Menu
            items={[
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price low to high',
                                    value: 'ASC',
                                    type: 'deducted_price',
                                })
                            }
                        >
                            Price low to high
                        </p>
                    ),
                    key: '1',
                },
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price high to low',
                                    value: 'DESC',
                                    type: 'deducted_price',
                                })
                            }
                        >
                            Price high to low
                        </p>
                    ),
                    key: '2',
                },
            ]}
        />
    );
    return (
        <div>
            <div className={cx('title_header')}>
                {isSearch ? (
                    <Row className={cx('header_row_search')}>
                        <Col xs={2}>
                            <img
                                src={SVGS.ImageChevronLeft}
                                alt="icon chevron left"
                                className={cx('btn_search')}
                                onClick={() => {
                                    navigate(config.routes.products);
                                }}
                            />
                        </Col>

                        <Col xs={22}>
                            <Row className={cx('search')}>
                                <SearchComponent>
                                    <Search
                                        placeholder="Search for products"
                                        value={keySearch}
                                        onChange={handleChangeKeySearch}
                                        onSearch={onSearch}
                                        enterButton
                                    />
                                </SearchComponent>
                            </Row>
                        </Col>
                    </Row>
                ) : (
                    <Row className={cx('header_row')}>
                        <Col>
                            <Row>
                                <img
                                    src={SVGS.ImageChevronLeft}
                                    alt="icon chevron left"
                                    className={cx('btn_search')}
                                    onClick={() => navigate(config.routes.products)}
                                />
                                <span className={cx('header_title')}>Product</span>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <img
                                    src={SVGS.ImageSearch}
                                    alt="icon search"
                                    className={cx('btn_search')}
                                    onClick={() => {
                                        setIsSearch(true);
                                    }}
                                />

                                <Badge
                                    count={cartItemsCount}
                                    showZero
                                    overflowCount={99}
                                    className="mt-3"
                                    style={{
                                        backgroundColor: '#FBBC12',
                                        color: '#333',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <img
                                        src={SVGS.IconCart}
                                        alt=""
                                        onClick={() => {
                                            navigate({
                                                pathname: '/gio-hang',
                                            });
                                        }}
                                    />
                                </Badge>
                            </Row>
                        </Col>
                    </Row>
                )}
                {!isSearch && categoryTitle?.title && !isHotDeal && (
                    <div className={cx('title_category')}>{categoryTitle?.title}</div>
                )}
                {!isSearch && isHotDeal && !categoryTitle && <div className={cx('title_category')}>Hot deal</div>}
                {!isSearch && (
                    <Row className={cx('search_header')}>
                        <span className={cx('search_title')}>Search:</span>
                        <span className={cx('search_key')}>{keySearch}</span>
                    </Row>
                )}

                {!isSearch && (
                    <div className={cx('title_sort')}>
                        <div className={cx('right_section')}>
                            <Row className={cx('filter')} align="middle">
                                <Row style={{ width: '100%' }}>
                                    <Dropdown overlay={menuSort} trigger={['click']}>
                                        <button onClick={(e) => e.preventDefault()} className={cx('button')}>
                                            <Row align="middle">
                                                <Col xs={3}>
                                                    <Row>
                                                        <img src={SVGS.ImageSwitch} alt="" />
                                                    </Row>
                                                </Col>
                                                <Col xs={18}>
                                                    <Row className={cx('title_select')}>
                                                        <span>
                                                            {filterOrder.value ? filterOrder.title : 'Options'}
                                                        </span>
                                                    </Row>
                                                </Col>
                                                <Col xs={3}>
                                                    <Row justify="end">
                                                        <img src={SVGS.ImageChevronDown} alt="" />
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </button>
                                    </Dropdown>
                                </Row>
                            </Row>
                        </div>
                        <div
                            className={cx('sort_price')}
                            onClick={() => {
                                setIsShowModalPrice(true);
                            }}
                        >
                            <img src={SVGS.ImageAdjustments} alt="" />
                            <span>Filter</span>
                        </div>
                    </div>
                )}
            </div>

            {!isSearch ? (
                listProduct?.length ? (
                    <>
                        <Row className={cx('container_service')} ref={scrollRef}>
                            {listProduct?.map((item, index) => {
                                return (
                                    <Col xs={12} sm={6} xl={8} key={index}>
                                        <Row>
                                            <ItemProduct data={item} />
                                        </Row>
                                    </Col>
                                );
                            })}
                        </Row>
                        <Row justify="center" style={{ margin: '10px 0' }}>
                            <PaginationCustom>
                                <Pagination
                                    defaultCurrent={1}
                                    current={pagination?.page}
                                    total={pagination?.total_item}
                                    pageSize={pagination?.limit}
                                    onChange={handleChangePagination}
                                />
                            </PaginationCustom>
                        </Row>
                    </>
                ) : (
                    <div className={cx('no_service')}>
                        <img src={SVGS.IconNoService} alt="" />
                        <span className={cx('no_service_span')}>No products</span>
                    </div>
                )
            ) : (
                <div className={cx('no_service')}></div>
            )}
            <Modal
                centered
                visible={isShowModalPrice}
                onCancel={() => setIsShowModalPrice(false)}
                maskClosable={false}
                footer={null}
                style={{ top: 230 }}
                className="otp-modal-price"
                width={500}
                destroyOnClose
            >
                <div style={{ padding: '0px 0px' }}>
                    <FormFilterPrice
                        title="Filter products"
                        isShowModalPrice={isShowModalPrice}
                        isCancel={handleSetShowModalPrice}
                        rangePrice={rangePrice}
                        setRangePrice={setRangePrice}
                    />
                </div>
            </Modal>
        </div>
    );
};

export default ProductsFilter;
